import { render, staticRenderFns } from "./taxi-in-goa.vue?vue&type=template&id=2281e6fa&scoped=true"
import script from "./taxi-in-goa.vue?vue&type=script&lang=js"
export * from "./taxi-in-goa.vue?vue&type=script&lang=js"
import style0 from "./taxi-in-goa.vue?vue&type=style&index=0&id=2281e6fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2281e6fa",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TaxiCard: require('/workspace/components/TaxiCard.vue').default,FaqCard: require('/workspace/components/FaqCard.vue').default})
